import { useState, useCallback, useEffect } from 'react';
import { useDebounce } from 'use-debounce';


function useTableSearch({
  searchableColumns = [],
  updateQueryParams,
  getQueryParams
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const searchValue = useDebounce(searchTerm, 300); // Debounce search input

  // Initialize search term from URL parameters
  useEffect(() => {
    const params = getQueryParams();
    if (params.search) {
      setSearchTerm(params.search);
    }
  }, [getQueryParams]);
  const handleSearchChange = useCallback((newSearchTerm) => {
    setSearchTerm(newSearchTerm);

    const searchParams = {};
    if (newSearchTerm && newSearchTerm.trim() !== "") {
      searchParams.search = newSearchTerm.trim();
    } else {
      searchParams.search = ''; // This will remove the search parameter from URL
    }
    
    // Reset to page 1 when searching
    searchParams.page = '1';

    updateQueryParams(searchParams, { replace: true });
  }, [updateQueryParams]);
  const applySearch = useCallback((data) => {
    if (!data || data.length === 0) {
      return data;
    }

    // Apply search filter with debounce
    const searchText = searchValue[0];
    if (!searchText || searchText.trim() === "" || searchableColumns.length === 0) {
      return data;
    }

    const searchTextLower = searchText.toLowerCase().trim();
    return data.filter((item) => {
      return searchableColumns.some((column) => {
        const value = item[column];
        if (value === null || value === undefined) return false;
        return String(value).toLowerCase().includes(searchTextLower);
      });
    });
  }, [searchValue, searchableColumns]);
  return {
    searchTerm,
    searchValue: searchValue[0], // Return the actual debounced value, not the array
    handleSearchChange,
    applySearch
  };
}

export default useTableSearch;
